import swal from "sweetalert";
export default {
  name: "invite-modal",
  props: ["auth"],
  components: {},
  data() {
    return {
      form: {
        type: "email",
        value: "",
        status: "pending",
        tag: "beta"
      }
    };
  },
  computed: {},
  methods: {
    noEmpty: function() {
      return this.form.value !== "";
    },
    validateEmail: function(email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    submit: function(e) {
      this.$props.auth
        .saveInvite(this.form)
        .then(() => {
          $("#inviteModal").modal("hide");
          swal(
            "",
            "Your email has been noted, you will be notified when we launch!",
            "success"
          );
        })
        .catch(response => this.$root.$emit("ShowErrorNotification", response.message));
    }
  }
};
